<template>
    <div class="datetime-pk-wrapper">
        <div class="datetime-pk-icon">
            <SvgIcon name="calendar" :width="18" :height="18"/>
        </div>
        <span class="text-muted pl-2 align-self-auto">{{$t(`sensors-page.analysis-modal.${fromTo}`)}}</span>
        <VueCtkDateTimePicker
            v-model="dateTime"
            @is-hidden="$emit('validate', new Date(dateTime))"
            :no-button-now="true"
            button-color="#6299EB"
            color="#6299EB"
            format="YYYY-MM-DD H:mm"
            formatted="l"
            :locale="$i18n.locale"
            :range="false"
            nput-size="sm"
            :no-header="true"
            :no-shortcuts="true"
            :class="['datetime-pk', 'd-inline', ...(center && ['datetime-pk-center'])]"
            :right="center ? center : right"
            :key="forceRefreshKey"
        >
            <b-button variant="link" class="datetime-pk-trigger p-1 m-0"></b-button>
        </VueCtkDateTimePicker>
    </div>
</template>

<script>
    // components
    import SvgIcon from './SvgIcon';
    // external
    import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
    import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

    import {formatDate} from "../../utils/common";

    export default {
        name: "DatePicker",
        components: {
            SvgIcon,
            VueCtkDateTimePicker
        },
        props: {
            date: Date,
            range: {
                type: Boolean,
                default: false
            },
            right: {
                type: Boolean,
                default: false
            },
            fromTo: {
                type: String,
                default: "from"
            },
            center: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                dateTime: formatDate(this.date)
            }
        },
        computed: {
            forceRefreshKey() {
                return this.date.getTime();
            }
        },
        watch: {
            date(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.dateTime = formatDate(newValue);
                }
            }
        }
    }
</script>

<style lang="scss">
    @import "src/assets/scss/variables.scss";

    .datetime-pk {
        &-wrapper {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            border: 1px solid $dt-pk-border-color;
            border-radius: $dt-pk-border-radius;
            width: 100%;
            max-width: $dt-pk-width;
            padding: 1px 16px;
        }

        &-icon {
            position: relative;
            width: 20px;

            /*.svg-icon {
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
            }*/
        }

        &-to {
            align-self: center;
            padding-left: 5px;
        }

        &-trigger {
            color: $darkColor;
            outline: none;
            &:focus {
                box-shadow: none !important;
            }
            &:hover {
                color: $menuBlue;
                text-decoration: none;
            }
        }
    }

    @include media-breakpoint-up(md) {
        .datetime-pk-center {
            & .datepicker {
                left: 50%;
                transform: translate(-50%);
            }
        }
    }
</style>